import type { FunctionComponent } from 'react';

import { ContentMarkdown } from '../../../shared/components/content-markdown/content-markdown';
import { StarRating } from '../../../shared/components/star-rating/star-rating';
import { createClassName, createStyleHelper } from '../../../shared/utils/class-names';

import styles from './game-seo-content.module.scss';

const style = createStyleHelper(styles, 'game-seo-content');

export interface IGameSeoContentProps {
    className?: string;
    gameRating: number;
    gameRatingDescription?: string | null;
    gameInfoDescriptionTitle?: string | null;
    gameInfoDescription?: string | null;
}

export const GameSeoContent: FunctionComponent<IGameSeoContentProps> = ({
    className,
    gameRating,
    gameRatingDescription,
    gameInfoDescriptionTitle,
    gameInfoDescription,
}) => {
    return (
        <div className={createClassName([className, style()])}>
            <div className={style('rating-stars')}>
                <StarRating ratingPercent={gameRating} className={style('stars')} />
            </div>
            <p className={style('rating-description')}>{gameRatingDescription}</p>
            <div className={style('game-description-title')}>
                <h1 className={style('game-description-title-text')}>{gameInfoDescriptionTitle}</h1>
            </div>
            <div className={style('game-description-info')}>
                {gameInfoDescription ? (
                    <ContentMarkdown
                        markdown={gameInfoDescription}
                        className={style('content-markdown')}
                    />
                ) : null}
            </div>
        </div>
    );
};
